export const formSchema = [
  {
    name: 'first_name',
    label: 'First Name*',
    defaultValue: '',
    validation: ['noEmpty'],
  },
  {
    name: 'last_name',
    label: 'Last Name*',
    defaultValue: '',
    validation: ['noEmpty'],
  },
  {
    name: 'email',
    label: 'Business Email*',
    defaultValue: '',
    validation: ['email'],
    full: true,
  },
  {
    name: 'business_name',
    label: 'Business Name*',
    defaultValue: '',
    validation: ['noEmpty'],
  },
  {
    name: 'phone',
    label: 'Phone Number',
    defaultValue: '',
    notRequired: true,
    validation: ['noEmpty'],
  },
];



// WEBPACK FOOTER //
// ./src/components/landing/components/demoForm/config.js